import {BookingEntityStorage} from "../storage/booking-entity-storage";
import {MaturePassengerSessionStorageKeys} from "./mature-passenger-session-storage-keys";
import {BookingSessionStorageKeys} from "../storage/booking-session-storage-keys";
import {MaturePassengerModel} from "./mature-passenger.model";

export class MaturePassengerSessionStorage extends BookingEntityStorage<MaturePassengerSessionStorageKeys> {
    constructor(passenger: MaturePassengerModel) {
        super({
            parentStorage: passenger.booking.storage,
            parentStorageKey: BookingSessionStorageKeys.maturePassengerStorage,
            getStorageDiscriminator: () => `MaturePassenger_${passenger.passengerIndex}`
        });
    }
}